import {AppAction} from '../appActions';
import {UpdateActionsEnum} from './updateActions';
import {UpdateState} from './updateState';

export function updateReducer(state: UpdateState = {}, action: AppAction): UpdateState {
  switch (action.type) {
    case UpdateActionsEnum.CRITICAL_UPDATE_AVAILABLE:
      return {criticalUpdateReloadTime: action.payload};

    default:
      return state;
  }
}
